import React from "react";
import { useLocation } from 'react-router-dom'; // Import hooks
import { useHistory } from "react-router-dom";
const Publicationviews = () => {
  const { state } = useLocation();
const history = useHistory();
  const publication = state ? state.publication : {}; // Get the publication details from the passed state

  return (
    <div className="container mt-4">
      <h2 className="text-center">View Publication</h2>
      <form>
        <div className="row mb-3">
          {/* Publication Type - Display as value */}
          <div className="form-group col-md-4">
            <label htmlFor="publication" className="form-label">
              Publication Type
            </label>
            <input
              type="text"
              id="publication"
              className="form-control"
              name="publication"
              value={publication.publication} // Assuming publication is coming from state
              readOnly
            />
          </div>

          {/* DOI - Display as value */}
          <div className="form-group col-md-8">
            <label htmlFor="doi" className="form-label">
              DOI/URL
            </label>
            <input
              type="text"
              id="doi"
              className="form-control"
              placeholder="Enter DOI"
              name="doi"
              value={publication.doi}
              readOnly
            />
          </div>

          {/* Title - Display as value */}
          <div className="form-group col-md-12">
            <label htmlFor="title" className="form-label">
              Title
            </label>
            <input
              type="text"
              id="title"
              className="form-control"
              placeholder="Enter title"
              name="title"
              value={publication.title}
              readOnly
            />
          </div>

          {/* Journal Name - Display as value */}
          <div className="form-group col-md-12">
            <label htmlFor="journal" className="form-label">
              Journal Name
            </label>
            <input
              type="text"
              id="journal"
              className="form-control"
              placeholder="Enter Journal Name"
              name="journal"
              value={publication.journal}
              readOnly
            />
          </div>


          <div className="form-group col-md-5">
                  <label htmlFor="claimed" className="form-label">
                   Claimend By
                  </label>
                  <input
                    type="text"
                    id="claimed"
                    className="form-control"
                    placeholder="Claimed by"
                    name="claimed"
                    value={publication.claimedBy}
                   readOnly
                  />
                </div>

                {/* Contribution Type Dropdown */}
                <div className="form-group col-md-4">
                  <label htmlFor="contribution" className="form-label">
                    Contribution Id
                  </label>
                 <input
                    id="contribution"
                    className="form-control"
                    name="contribution"
                    value={publication.contribution}
                  readOnly
                  />
                   
                </div>

                {/* Reach Type Dropdown */}
                <div className="form-group col-md-3">
                  <label htmlFor="reach" className="form-label">
                    Reach
                  </label>
                  <input
                    id="reach"
                    className="form-control"
                    name="reach"
                    value={publication.reach}
                  readOnly>
                 
                  </input>
                </div><div className="form-group col-md-3">
                  <label htmlFor="volnum" className="form-label">
                    Volume Number
                  </label>
                  <input
                    type="text"
                    id="volnum"
                    className="form-control"
                    placeholder="Volume Number"
                    name="volnum"
                    value={publication.volnum}
                    readOnly
                  />
                </div>
                <div className="form-group col-md-3">
                  <label htmlFor="date" className="form-label">
                    Publication Date
                  </label>
                  <input
                    type="date"
                    id="date"
                    className="form-control"
                    name="date"
                    value={publication.date}
                   readOnly
                  />
                </div>
                <div className="form-group col-md-3">
                  <label htmlFor="pfrom" className="form-label">
                    Page From
                  </label>
                  <input
                    type="text"
                    id="pfrom"
                    className="form-control"
                    placeholder="From page"
                    name="pfrom"
                    value={publication.pfrom}
                   readOnly
                  />
                </div>
                <div className="form-group col-md-3">
                  <label htmlFor="pto" className="form-label">
                    Page To
                  </label>
                  <input
                    type="text"
                    id="pto"
                    className="form-control"
                    placeholder="From to"
                    name="pto"
                    value={publication.pto}
                    readOnly
                    
                  />
                </div>
                <div className="form-group col-md-6">
                  <label htmlFor="issn" className="form-label">
                    ISSN
                  </label>
                  <input
                    type="text"
                    id="issn"
                    className="form-control"
                    placeholder="ISSN"
                    name="issn"
                    value={publication.issn}
                    readOnly
                  
                  />
                </div>
                <div className="form-group col-md-6">
                  <label htmlFor="isbn" className="form-label">
                    ISBN
                  </label>
                  <input
                    type="text"
                    id="isbn"
                    className="form-control"
                    placeholder="ISBN"
                    name="isbn"
                    value={publication.isbn}
                   readOnly
                  />
                </div>
                <div className="form-group col-md-6">
                  <label htmlFor="indexing" className="form-label">
                    Indexing
                  </label>
                  <input
                    id="indexing"
                    className="form-control"
                    name="indexing"
                    value={publication.indexing}
                   readOnly>
                    </input>

                  
                 
                </div>
                <div className="form-group col-md-6">
                  <label htmlFor="issuenum" className="form-label">
                    Issue Number
                  </label>
                  <input
                    type="text"
                    id="issuenum"
                    className="form-control"
                    placeholder="Issue Number"
                    name="issuenum"
                    value={publication.issuenum}
                   readOnly
                  />
                </div>
                <div className="form-group col-md-6">
                  <label htmlFor="impactfactor" className="form-label">
                    Impact Factor
                  </label>
                  <input
                    type="text"
                    id="impactfactor"
                    className="form-control"
                    placeholder="Impact Factorr"
                    name="impactfactor"
                    value={publication.impactfactor}
                    readOnly
                   
                  />
                </div>


                {/* Username Input */}
                <div className="form-group col-md-6">
                  <label htmlFor="editionno" className="form-label">
                    Edition number
                  </label>
                  <input
                    type="text"
                    id="editionno"
                    className="form-control"
                    placeholder="Enter Endition no"
                    name="editionno"
                    value={publication.editionno}
                   readOnly
                  />
                </div>
                <div className="form-group col-md-12">
  <label htmlFor="collegeCoauthors" className="form-label">
    Sona Co-authors
  </label>
  <div className="row">
    {publication.collegeCoauthors && publication.collegeCoauthors.slice(0, 6).map((coauthor) => (
      <div key={coauthor.userId} className="col-md-6 mb-3">
        <div className="card shadow-sm border-0 rounded">
          <div className="card-body">
            <h5 className="card-title mb-1">{coauthor.username}</h5>
            <p className="card-text mb-0"><strong>Designation:</strong> {coauthor.designation}</p>
            <p className="card-text mb-1"><strong>Email:</strong> <a href={`mailto:${coauthor.email}`}>{coauthor.email}</a></p>
            <p className="card-text mb-1"><strong>Specialization:</strong> {coauthor.specialization}</p>
            <p className="card-text mb-0"><strong>Department:</strong> {coauthor.department.deptName} - {coauthor.department.deptDesc}</p>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>


          {/* Remove unnecessary fields */}
          {/* Edition Number, Coauthor, and Author fields removed */}
        </div>
      </form>
    </div>
  );
};

export default Publicationviews;
